import { render } from "./ThreeCircles-1.vue?vue&type=template&id=4356140a&scoped=true"
import script from "./ThreeCircles-1.vue?vue&type=script&lang=js"
export * from "./ThreeCircles-1.vue?vue&type=script&lang=js"

import "@/assets/css/circlestyles.css?vue&type=style&index=0&id=4356140a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4356140a"]])

export default __exports__